import { render } from "./LocationComponent.vue?vue&type=template&id=dc5b9130"
import script from "./LocationComponent.vue?vue&type=script&lang=js"
export * from "./LocationComponent.vue?vue&type=script&lang=js"

import "./LocationComponent.vue?vue&type=style&index=0&id=dc5b9130&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__